// extracted by mini-css-extract-plugin
export default {"link":"redirect_link__crfge","redirectIcon":"redirect_redirectIcon__5yT46"};